import React from 'react';

import {
  Button,
  DialogContent,
  Flex,
  H4,
  InlineNotification,
  LssProp
} from '@lucidhq/lucidium';

import { t } from '~/utils/i18n';

const dialogContentLss: LssProp = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '1.5rem',
  padding: '2rem 1rem'
};

const buttonLss: LssProp = {
  display: 'flex',
  maxWidth: '5.5rem',
  alignSelf: 'center',
  justifyContent: 'center'
};

type DuplicateIDsDialogContentProps = {
  handleToggle: () => void;
  duplicateStr: string;
};

export const DuplicateIDsDialogContent = ({
  handleToggle,
  duplicateStr
}: DuplicateIDsDialogContentProps) => {
  return (
    <DialogContent lss={dialogContentLss}>
      <Flex lss={{ gap: '3rem', flexDirection: 'column' }}>
        <H4 lss={{ textWrap: 'balance', textAlign: 'center' } as LssProp}>
          {t('ipMatching.duplicateIDsDialog.title')}
        </H4>
        <InlineNotification
          iconLss={{ color: 'primary', alignSelf: 'flex-start' }}
          palette="warning"
          title={t('ipMatching.duplicateIDsDialog.notificationTitle')}
          lss={{ wordWrap: 'normal' }}
        >
          {t('ipMatching.duplicateIDsDialog.notificationMsg', {
            duplicateIds: duplicateStr
          })}
        </InlineNotification>
      </Flex>
      <Button
        type="button"
        scale="md"
        palette="secondary"
        emphasis="high"
        onClick={handleToggle}
        lss={buttonLss}
      >
        {t('ipMatching.actions.close')}
      </Button>
    </DialogContent>
  );
};
